import { matchPath } from 'react-router-dom';
import { paths } from './paths';
import { ThemeName } from '@shared/theme';

export const getRouteForcedTheme = (pathname: string): ThemeName | undefined => {
  return matchPath({ end: false, path: paths.calc }, pathname) ? 'light' : undefined;
};